angular.module('picmonicng').factory('QuizService', [
  'Tracks',
  'Playlists',
  '$filter',
  'Navigation',
  '$rootScope',
  'User',
  'ngBowser',
  'ClassificationService',
  'FactsResource',
  '$timeout',
  '$modal',
  'MetaService',
  'PermissionsService',
  '$cookies',
  'UserService',
  'TokenService',
  '$state',
  'Picmonics',
  'Pathways',
  'MarketOptionsConfig',
  '$location',
  '$window',
  '$interval',
  '$q',
  'XpService',
  'studyplansResource',
  'PicmonicQueue',
  function (
    Tracks,
    Playlists,
    $filter,
    Navigation,
    $rootScope,
    User,
    ngBowser,
    ClassificationService,
    FactsResource,
    $timeout,
    $modal,
    MetaService,
    PermissionsService,
    $cookies,
    UserService,
    TokenService,
    $state,
    Picmonics,
    Pathways,
    MarketOptionsConfig,
    $location,
    $window,
    $interval,
    $q,
    XpService,
    studyplansResource,
    PicmonicQueue
  ) {
    return {
      init: function (type, slug, resource, stateParams, initOnly) {
        var self = this;
        this.playerService = {
          mode: 'mini',
          assetStatus: [],
          assetsLoaded: false,
          animationDone: false,
          location: 'quiz',
          getSlowSpeedMode: function () {
            return UserService.user.user_id
              ? typeof UserService.user.settings.slow_connection_mode !== 'undefined'
                ? UserService.user.settings.slow_connection_mode
                : 0
              : 0;
          },
        };
        this.facts = [];
        this.picmonics = {};
        this.quiz_round = {};
        this.currentQuestion = {};
        try {
          this.show_answer_key = localStorage.getItem('show_answer_key');
        } catch (e) {
          this.show_answer_key = true;
        }

        if (type === 'picmonic') {
          this.currentQuestion.picmonic = resource.currentCard;
          this.currentQuestion.showPicmonic = UserService.user.user_id ? UserService.user.quiz_show_picmonic : true;
        }
        this.quizInProgress = false;
        this.quizComplete = false;
        this.loading = true;
        this.manageOpen = false;
        this.factFeedbackOptions = [
          { text: "It's too easy." },
          { text: "It's out of place (or random)." },
          { text: "It's similar to the correct answer." },
          { text: "It's a correct answer." },
        ];

        this.quizQuestionFeedbackOptions = [
          { text: "It's too easy." },
          { text: "It's confusing or misleading." },
          { text: 'There is a typo.' },
          { text: 'There is an academic or information error.' },
        ];

        this.stateParams = stateParams;
        this.quiz_type = type;
        slug = slug.replace('/', '');
        this.slug = slug;
        this.resource_id =
          slug.lastIndexOf('_') === -1
            ? slug.lastIndexOf('-') === -1
              ? slug
              : slug.substring(slug.lastIndexOf('-') + 1)
            : slug.substring(slug.lastIndexOf('_') + 1);
        this.resource_type = this.quiz_type;
        this.quizMode = 'multiple-choice';
        this.customAnswer = {};

        this.isQuizAdmin = PermissionsService.hasAccess('admin', 'quiz');

        this.incorrectAudio = document.createElement('audio');
        this.correctAudio = document.createElement('audio');

        this.incorrectAudio.autoPlay = false;
        this.correctAudio.autoPlay = false;

        this.incorrectAudio.preload = 'auto';
        this.correctAudio.preload = 'auto';

        this.incorrectAudio.src = $rootScope.base_asset_url + '/assets/sound/incorrect.mp3';
        this.correctAudio.src = $rootScope.base_asset_url + '/assets/sound/correct.mp3';

        this.questionsAnswered = 0;
        this.spacedRepQuestionsAnswered = 0;

        if (UserService.user.quiz_mute) {
          this.incorrectAudio.muted = true;
          this.correctAudio.muted = true;
        }

        this.xpEarned = 0;

        MetaService.replace('%QUIZ%', 'Loading');
        MetaService.replace('%ACCURACY%', '0%');

        if (UserService.user.user_id && UserService.user.lead) {
          market = MarketOptionsConfig.getMarketById(UserService.user.lead);
        }

        //if (!UserService.user.has_seen.modal_hard_mode) {
        //    UserService.see('modal_hard_mode');
        //
        //    $modal.open({
        //        templateUrl: '/templates/modals/quiz-hard-mode.html',
        //        windowClass: 'pls-modal-abyss',
        //        backdropClass: 'above-nav',
        //        controller: ['$scope', 'UserService', '$modalInstance', function ($scope, UserService, $modalInstance) {
        //            $scope.UserService = UserService;
        //
        //            $scope.turnOff = function() {
        //                UserService.user.settings.hard_mode = 0;
        //               UserService.user.$update();
        //                $modalInstance.close();
        //            }
        //        }]
        //    });
        //}

        ClassificationService.classifications.$promise.then(function () {
          switch (self.resource_type) {
            case 'pathway':
              self.resource = Pathways.getv3({ pathway_id: self.resource_id }, function () {
                MetaService.replace('%QUIZ%', self.resource.name);
              });

              Pathways.getv3({
                pathway_id: self.resource_id,
                resource: 'questions',
                facts_only: 1,
                quiz_all: self.stateParams.quiz_all,
                questions: self.stateParams.questions,
              }).$promise.then(function (data) {
                /*angular.forEach(data.picmonics, function (card) {
                                    self.preloadImage(card.background_image_url);
                                    card.topicFact = $filter('filter')(card.facts, {is_primary: 1}, true)[0];
                                });*/

                angular.forEach(data.facts, function (fact) {
                  fact.option_order = Math.floor(Math.random() * 100);
                  fact.is_answer = true;
                  // fact.card = $filter('filter')(data.picmonics, {id: fact.card_id}, true)[0];
                  self.facts.push(fact);
                });

                self.loading = false;

                if (self.quiz_type === 'pathway') {
                  self.startQuiz(self.stateParams.quiz_all || self.stateParams.questions ? true : false);
                }
              });

              break;
            case 'track':
              self.resource = Tracks.get({ track_id: self.resource_id }, function () {
                MetaService.replace('%QUIZ%', self.resource.name);
              });

              Tracks.get({
                track_id: self.resource_id,
                resource: 'questions',
                facts_only: 1,
                quiz_all: self.stateParams.quiz_all,
                questions: self.stateParams.questions,
              }).$promise.then(function (data) {
                /*angular.forEach(data.picmonics, function (card) {
                                    self.preloadImage(card.background_image_url);
                                    card.topicFact = $filter('filter')(card.facts, {is_primary: 1}, true)[0];
                                });*/

                angular.forEach(data.facts, function (fact) {
                  fact.option_order = Math.floor(Math.random() * 100);
                  fact.is_answer = true;
                  // fact.card = $filter('filter')(data.picmonics, {id: fact.card_id}, true)[0];
                  self.facts.push(fact);
                });

                self.loading = false;

                if (self.quiz_type === 'track') {
                  self.startQuiz(self.stateParams.quiz_all || self.stateParams.questions ? true : false);
                }
              });

              break;
            case 'playlist':
              self.resource = Playlists.getv3({ playlist_id: self.resource_id }, function () {
                MetaService.replace('%QUIZ%', self.resource.name);
              });

              Playlists.getv3(
                {
                  playlist_id: self.resource_id,
                  resource: 'questions',
                  facts_only: 1,
                },
                function (data) {
                  /*angular.forEach(data.picmonics, function (card) {
                                    self.preloadImage(card.background_image_url);
                                    card.topicFact = $filter('filter')(card.facts, {is_primary: 1}, true)[0];
                                });*/

                  angular.forEach(data.facts, function (fact) {
                    fact.option_order = Math.floor(Math.random() * 100);
                    fact.is_answer = true;
                    //fact.card = $filter('filter')(data.picmonics, {id: fact.card_id}, true)[0];
                    self.facts.push(fact);
                  });

                  self.loading = false;

                  self.startQuiz(false);
                }
              );
              break;
            case 'studyplan':
              self.resource = studyplansResource.get({ studyplan_id: self.resource_id }, function () {
                MetaService.replace('%QUIZ%', self.resource.name);
              });

              studyplansResource
                .get({
                  studyplan_id: self.resource_id,
                  resource: 'questions',
                  facts_only: 1,
                  quiz_all: self.stateParams.quiz_all,
                  limit: self.stateParams.questions,
                })
                .$promise.then(function (data) {
                  var facts = $filter('orderBy')(data.facts, ['sort_order']);

                  angular.forEach(facts, function (fact) {
                    fact.option_order = Math.floor(Math.random() * 100);
                    fact.is_answer = true;
                    self.facts.push(fact);
                  });

                  self.loading = false;
                  self.startQuiz(self.stateParams.quiz_all || self.stateParams.questions ? true : false);
                });

              break;
            case 'picmonic':
              resource.currentCard.facts = resource.currentFacts;
              var card = (self.resource = resource.currentCard);
              MetaService.replace('%QUIZ%', card.name);

              self.preloadImage(card.background_image_url);
              card.topicFact = $filter('filter')(card.facts, { is_primary: 1 }, true)[0];

              angular.forEach(
                $filter('filter')(card.facts, {
                  is_primary: '!1',
                  header: '!1',
                }),
                function (fact) {
                  fact.option_order = Math.floor(Math.random() * 100);
                  fact.is_answer = true;
                  fact.card = card;
                  self.facts.push(fact);
                }
              );

              self.loading = false;

              if (!initOnly) {
                self.startQuiz(true);
              }

              break;

            case 'spacedrep':
              self.resource = {
                name: "Today's Spaced Repetition",
              };

              MetaService.replace('%QUIZ%', self.resource.name);

              var params = { resource: 'spacedrep' };

              if (stateParams.card_id) {
                params.card_id = stateParams.card_id;
                Picmonics.get({ card_id: params.card_id }, function (data) {
                  self.resource.filter = data.name;
                });
              } else if (stateParams.track_id) {
                params.track_id = stateParams.track_id;
                Tracks.get({ track_id: params.track_id }, function (data) {
                  self.resource.filter = data.name;
                });
              } else if (stateParams.pathway_id) {
                params.pathway_id = stateParams.pathway_id;
                Pathways.getv3({ pathway_id: params.pathway_id }, function (data) {
                  self.resource.filter = data.name;
                });
              } else if (stateParams.playlist_id) {
                params.playlist_id = stateParams.playlist_id;
                Playlists.getv3({ playlist_id: params.playlist_id }, function (data) {
                  self.resource.filter = data.name;
                });
              }

              User.getv3(params, function (data) {
                var picmonics = {};
                angular.forEach(data.picmonics, function (card) {
                  self.preloadImage(card.background_image_url);
                  card.topicFact = $filter('filter')(card.facts, { is_primary: 1 }, true)[0];
                  picmonics[card.card_id] = card;
                });
                var fact_stats = $filter('orderBy')(data.facts, ['sort_order']);
                angular.forEach(fact_stats, function (fact_stat) {
                  fact = $filter('filter')(picmonics[fact_stat.card_id].facts, { fact_id: fact_stat.fact_id }, true)[0];
                  fact.option_order = Math.floor(Math.random() * 100);
                  fact.is_answer = true;
                  fact.card = picmonics[fact.card_id];
                  self.facts.push(fact);
                });

                self.loading = false;

                self.startQuiz(true);
              });
              break;
          }
        });
      },

      toggleAnswerKey: function () {
        this.show_answer_key = !this.show_answer_key;

        try {
          localStorage.setItem('show_answer_key', this.show_answer_key);
        } catch (e) {}
      },

      addHotKeys: function (hotkeys) {
        var self = this;
        hotkeys
          .add({
            combo: '1',
            description: 'Select answer 1',
            callback: function () {
              if (self.quizMode === 'fill-in-the-blank') {
                return false;
              }

              self.selectAnswerByIndex(0);
              return false;
            },
          })
          .add({
            combo: '2',
            description: 'Select answer 2',
            callback: function () {
              if (self.quizMode === 'fill-in-the-blank') {
                return false;
              }

              self.selectAnswerByIndex(1);
              return false;
            },
          })
          .add({
            combo: '3',
            description: 'Select answer 3',
            callback: function () {
              if (self.quizMode === 'fill-in-the-blank') {
                return false;
              }

              self.selectAnswerByIndex(2);
              return false;
            },
          })
          .add({
            combo: '4',
            description: 'Select answer 4',
            callback: function () {
              if (self.quizMode === 'fill-in-the-blank') {
                return false;
              }

              self.selectAnswerByIndex(3);
              return false;
            },
          })
          .add({
            combo: '5',
            description: 'Select answer 5',
            callback: function () {
              if (self.quizMode === 'fill-in-the-blank') {
                return false;
              }

              self.selectAnswerByIndex(4);
              return false;
            },
          })
          .add({
            combo: '6',
            description: 'Select answer 6',
            callback: function () {
              if (self.quizMode === 'fill-in-the-blank') {
                return false;
              }

              self.selectAnswerByIndex(5);
              return false;
            },
          })
          .add({
            combo: 'enter',
            description: 'Next Question',
            callback: function () {
              if (self.currentQuestion.answerSelected && !self.currentQuestion.loadingQuestion && !self.quizComplete) {
                self.nextQuestion();
              }
              return false;
            },
          });
      },

      selectAnswerByIndex: function (index) {
        var self = this;
        if (
          self.LearnService.player_mode === 'quiz' &&
          self.currentQuestion.answers &&
          !self.currentQuestion.answerSelected &&
          !self.currentQuestion.loadingQuestion &&
          !self.quizComplete
        ) {
          self.answerQuiz($filter('orderBy')(self.currentQuestion.answers, '+option_order')[index]);
        }
        return false;
      },

      openManage: function () {
        var self = this;
        self.manageOpen = true;

        if (!self.currentQuestion.extraDistractorsLoaded) {
          self.currentQuestion.userDistractors = FactsResource.query({
            fact_id: self.currentQuestion.fact.fact_id,
            resource: 'distractors',
            type: 'user',
          }).$promise.then(function (data) {
            var answersVoteSeen = [];
            angular.forEach(data, function (distractor) {
              answersVoteSeen.push(distractor.fact_id);
            });

            if (answersVoteSeen.length) {
              FactsResource.updatev3({
                fact_id: self.currentQuestion.fact.fact_id,
                distractor_ids: answersVoteSeen,
                resource: 'distractorviews',
              });
            }
          });

          FactsResource.query({
            fact_id: self.currentQuestion.fact.fact_id,
            resource: 'distractors',
            type: 'community',
          }).$promise.then(function (data) {
            self.currentQuestion.communityDistractors = data;

            FactsResource.query({
              fact_id: self.currentQuestion.fact.fact_id,
              resource: 'distractors',
              type: 'generated',
            }).$promise.then(function (data) {
              self.currentQuestion.generatedDistractors = data;
              self.showMoreDistractors(4, 5);
            });
          });

          self.currentQuestion.extraDistractorsLoaded = true;
        }
      },

      closeManage: function () {
        var self = this;
        this.manageOpen = false;

        UserService.see('distractor_info');
      },

      showMoreDistractors: function (numCommunityDistractors, numTotalDistractors) {
        var self = this;
        var answersVoteSeen = [];
        var distractor;

        while (numCommunityDistractors && self.currentQuestion.communityDistractors.length) {
          distractor = self.currentQuestion.communityDistractors.shift();

          self.currentQuestion.showDistractors.push(distractor);
          answersVoteSeen.push(distractor.fact_id);
          numCommunityDistractors--;
          numTotalDistractors--;
        }

        while (numTotalDistractors && self.currentQuestion.generatedDistractors.length) {
          distractor = self.currentQuestion.generatedDistractors.shift();

          self.currentQuestion.showDistractors.push(distractor);
          answersVoteSeen.push(distractor.fact_id);
          numTotalDistractors--;
        }

        if (answersVoteSeen.length) {
          FactsResource.updatev3({
            fact_id: self.currentQuestion.fact.fact_id,
            distractor_ids: answersVoteSeen,
            resource: 'distractorviews',
          });
        }
      },

      firstQuestion: function (quiz_all) {
        var self = this;

        if (self.quiz_type === 'spacedrep') {
          self.quiz_round.facts = $filter('filter')(self.facts, {
            seen: '!1',
          }).concat(
            $filter('filter')(self.facts, {
              seen: '1',
              last_answer: '0',
            })
          );
        } else if (this.quiz_type === 'studyplan') {
          self.quiz_round.facts = $filter('filter')(self.facts, {
            last_answer: '!1',
          });
        } else if (quiz_all) {
          self.quiz_round.facts = self.facts.slice(0);
        } else {
          self.quiz_round.facts = $filter('filter')(self.facts, {
            last_answer: '!1',
          });
          if (self.quiz_round.facts.length === 0) {
            self.quiz_round.facts = self.facts.slice(0);
          }
        }

        angular.forEach(self.quiz_round.facts, function (fact) {
          fact.selected = false;
        });

        self.quiz_round.question_count = self.quiz_round.facts.length;

        self.quiz_round.num_attempts = 0;
        self.quiz_round.num_correct = 0;
        self.quiz_round.card_ids = [];
        self.quiz_round.question_number = 0;
        self.quiz_round.hints_used = 0;

        self.cacheNextQuestion();
        self.nextQuestion();
      },

      startQuiz: function (quiz_all) {
        var self = this;
        this.quizComplete = false;
        this.quizInProgress = true;
        this.xpEarned = 0;
        var filter_id = null;
        var filter_type = null;

        angular.element('body').scrollTop(0);
        if (window.innerWidth < 768) {
          Navigation.topVisible = false;
        }

        if (self.stateParams.card_id) {
          filter_id = self.stateParams.card_id;
          filter_type = 'card';
        } else if (self.stateParams.track_id) {
          filter_id = self.stateParams.track_id;
          filter_type = 'track';
        } else if (self.stateParams.pathway_id) {
          filter_id = self.stateParams.pathway_id;
          filter_type = 'pathway';
        } else if (self.stateParams.playlist_id) {
          filter_id = self.stateParams.playlist_id;
          filter_type = 'playlist';
        }

        this.round = User.savev3(
          {
            resource: 'quizround',
            quiz_resource_id: this.resource_id,
            quiz_resource_type: this.quiz_type,
            initial_time: 0,
            source_device: ngBowser.getPlatformType(),
            playlist_id: this.playlist_id,
            track_id: this.track_id,
            filter_id: filter_id,
            filter_type: filter_type,
          },
          function () {
            self.firstQuestion(quiz_all);
            if (self.LearnService) {
              self.LearnService.quizRoundId = self.round.user_quiz_round_id;
            }
          }
        );

        if (this.quiz_type === 'spacedrep') {
          UserService.see('spaced_repetition_launched', true);
        }
      },

      getFactQuestion: function (fact, quizMode) {
        var question = 'Which key fact is part of %TOPIC%?';

        if (quizMode === 'fill-in-the-blank' && !fact.question_text) {
          if (fact.card.primary_market_id == 108) {
            question = 'What is the meaning of %TOPIC%?';
          } else if (fact.classification_id) {
            question = ClassificationService.getClassificationById(fact.classification_id).fitb_question_text;
          }
        } else {
          if (fact.question_text) {
            question = fact.question_text;
          } else if (fact.classification_id) {
            question = ClassificationService.getClassificationById(fact.classification_id).question_text;
          }
        }

        return question.replace('%TOPIC%', '<strong>' + fact.card.name + '</strong>');
      },

      cacheNextQuestion: function () {
        if (!this.quiz_round.facts.length) {
          this.nextFact = false;
          return;
        }

        var fact;
        if (this.quiz_type === 'spacedrep' || this.quiz_type === 'studyplan') {
          fact = this.quiz_round.facts.splice(0, 1)[0];
        } else if (self.quiz_type === 'track' || self.quiz_type === 'pathway') {
          fact = this.quiz_round.facts.shift();
        } else {
          fact = this.quiz_round.facts.splice(Math.floor(Math.random() * this.quiz_round.facts.length), 1)[0];
        }
        fact.distractors = FactsResource.query({
          fact_id: fact.fact_id,
          resource: 'distractors',
        });
        if (!fact.card) {
          if (!this.picmonics[fact.card_id]) {
            this.picmonics[fact.card_id] = this.LearnService.getCard(fact.card_id, false, false);
          }
          this.picmonics[fact.card_id].then(function (card) {
            fact.card = card.currentCard;
            fact.card.topicFact = $filter('filter')(fact.card.facts, {
              is_primary: 1,
            })[0];
            fact.characters = $filter('filter')(fact.card.facts, {
              fact_id: fact.fact_id,
            })[0].characters;
          });
        }

        fact.promise = $q.all([fact.distractors.$promise, this.picmonics[fact.card_id]]);

        this.nextFact = fact;
      },

      nextQuestion: function () {
        var self = this,
          fact;
        if (self.LearnService) {
          if (self.LearnService.player_mode != 'quiz') {
            self.LearnService.saveCardAttempt(0);
          }
          self.LearnService.player_mode = 'quiz';
          if (self.LearnService.audioElement) {
            self.LearnService.audioElement.pause();
          }
        }
        self.currentQuestion.loadingQuestion = true;
        self.customAnswer = {
          name: '',
        };

        angular.element('body').scrollTop(0);
        angular.element('.main-content').scrollTop(0);

        $rootScope.$broadcast('miniPlayerPause');

        if (this.currentQuestion.answerSelected) {
          this.splicePicmonic();
        }

        if (!this.nextFact) {
          this.endQuiz();
          return;
        }

        if (this.currentQuestion.answerSelected) {
          this.saveFactStat();
        }

        fact = this.nextFact;
        this.cacheNextQuestion();

        var quizMode = 'multiple-choice';
        //var num = Math.floor(Math.random() * 4);
        //if ((self.quiz_round.question_count === 1) || (!fact.classification_id) || (num == 3 && UserService.user.settings.hard_mode)) {

        this.playerService.assetsLoaded = false;

        fact.promise.then(function (resolved) {
          if (self.LearnService.currentCard.card_id != fact.card_id) {
            self.LearnService.getCard(fact.card_id, false, true).then(function (resolvedData) {
              self.LearnService.init(resolvedData);
              if (self.LearnService.audioElement) {
                self.LearnService.setAudioSrc();
              }
            });
          }

          if (
            fact.card.primary_market_id === 108 ||
            (fact.card.entity_type_id === 2 && fact.card.entity_id === 379405)
          ) {
            quizMode = 'fill-in-the-blank';
          }

          var question = {
            fact: fact,
            question: self.getFactQuestion(fact, quizMode),
            question_image_url: fact.question_image_url,
            mobile_question_image_visible: !!fact.question_image_url,
            picmonic: fact.card,
            answers: [fact],
            startTime: Math.floor(Date.now() / 1000),
            loadingQuestion: true,
            answered_zoom: false,
            answerSelected: false,
            showCover: true,
            showPicmonic: UserService.user.user_id ? UserService.user.quiz_show_picmonic : true,
          };

          if (quizMode === 'fill-in-the-blank') {
            question.showPicmonic = true;
          }

          var distractors = fact.distractors;

          var num_distractors = 5;
          if (distractors.length < num_distractors) {
            num_distractors = distractors.length;
          }

          for (b = 0; b < num_distractors; b++) {
            var randomAnswer = distractors.shift();
            randomAnswer.option_order = Math.floor(Math.random() * 100);

            question.answers.push(randomAnswer);
          }

          question.loadingQuestion = false;
          self.currentQuestion = question;
          self.quizMode = quizMode;
          self.currentQuestion.showDistractors = [];
          self.currentQuestion.extraDistractorsLoaded = false;
          self.playerService.animationDone = false;
          self.quiz_round.question_number++;
        });

        $window.scrollTo(0, angular.element('h1.pathways-title:visible').offsetTop);

        // Focus on the question (ADA)
        angular.element('h1.pathways-title:visible').focus();
      },

      hideCover: function () {
        this.currentQuestion.showCover = false;
        this.quiz_round.hints_used++;
      },

      showPicmonic: function () {
        this.currentQuestion.showPicmonic = true;
      },

      saveFactStat: function () {
        var self = this;

        var resource = User.savev3({
          resource: 'facts',
          resource2: 'stats',
          resource_id: this.currentQuestion.fact.fact_id,
          quiz_round_id: this.round.user_quiz_round_id,
          last_answer: this.currentQuestion.is_correct ? 1 : 0,
          start_time: this.currentQuestion.startTime,
          answer_time: this.currentQuestion.answerTime,
          selected_fact_id: this.currentQuestion.selectedFactId,
          last_answer_hint: this.currentQuestion.showCover ? 0 : 1,
          end_time: Math.floor(Date.now() / 1000),
          spaced_rep_factor: this.currentQuestion.fact.spaced_rep_factor,
          remove_picmonic: this.currentQuestion.fact.remove_picmonic,
          picmonic_factor: this.currentQuestion.fact.picmonic_factor,
        });

        var correct = this.currentQuestion.is_correct ? 1 : 0;

        resource.$promise.then(function (factStatResult) {
          if (correct) {
            XpService.grant('QuizQuestion', factStatResult.user_fact_attempt_id).$promise.then(function (xpResult) {
              self.xpEarned += xpResult.amount;
            });
          }
        });

        return resource;
      },

      removePicmonic: function () {
        this.currentQuestion.fact.remove_picmonic = !this.currentQuestion.fact.remove_picmonic;

        if (this.currentQuestion.fact.remove_picmonic) {
          this.quiz_round.question_count = $filter('filter')(this.facts, {
            card_id: '!' + this.currentQuestion.fact.card_id,
          }).length;
        } else {
          this.quiz_round.question_count = this.facts.length;
        }
      },

      splicePicmonic: function () {
        if (this.currentQuestion.fact.spaced_rep_factor === 0) {
          this.quiz_round.facts.splice(this.facts.indexOf(this.currentQuestion.fact), 1);
        }

        if (this.currentQuestion.fact.remove_picmonic) {
          this.quiz_round.question_number--;
          this.facts = $filter('filter')(this.facts, {
            card_id: '!' + this.currentQuestion.fact.card_id,
          });
          this.quiz_round.facts = $filter('filter')(this.quiz_round.facts, {
            card_id: '!' + this.currentQuestion.fact.card_id,
          });
        }
      },

      updateSpacedRepFactor: function (factor) {
        this.currentQuestion.fact.spaced_rep_factor = factor;
      },

      updatePicmonicFactor: function (factor) {
        var self = this;

        self.currentQuestion.fact.picmonic_factor = factor;
        angular.forEach(self.quiz_round.facts, function (fact) {
          if (fact.card_id == self.currentQuestion.fact.card_id) {
            fact.spaced_rep_factor = factor;
          }
        });
      },

      removePicmonicFactor: function (factor) {
        this.currentQuestion.fact.picmonic_factor = null;
      },

      submitAnswer: function (answer) {
        var self = this;
        if (answer) {
          self.customAnswer.name = answer.name;
        }

        var limit = 3;
        if (self.currentQuestion.fact.name.length < 3) {
          limit = self.currentQuestion.fact.name.length;
        }

        if (
          self.customAnswer.name.length > limit - 1 &&
          self.currentQuestion.fact.name.toLowerCase().indexOf(self.customAnswer.name.toLowerCase()) !== -1
        ) {
          self.customAnswer = this.currentQuestion.fact;
        }

        self.answerQuiz(self.customAnswer);
      },

      answerQuiz: function (answer, $event) {
        var self = this;
        $interval.cancel(self.interval);

        angular.element('body').scrollTop(0);
        angular.element('.main-content').scrollTop(0);

        if (!this.currentQuestion.answerSelected) {
          this.currentQuestion.answerTime = Math.floor(Date.now() / 1000);
          this.currentQuestion.selectedFactId = answer.fact_id;
          this.currentQuestion.answerSelected = true;
          $timeout(function () {
            self.currentQuestion.showDownvotes = true;

            // Onboarding modals are shown during the next digest cycle after quiz answer text has been shown
            // and the up/down vote slide animations are complete
            if (
              UserService.user.user_id &&
              !UserService.user.is_trial &&
              self.questionsAnswered >= 10 &&
              self.quiz_round.num_correct - self.quiz_round.num_attempts < -1 &&
              !UserService.seen('distractor_onboarding') &&
              !$rootScope.embed
            ) {
              $timeout(self.showDistractorOnboarding, 0, true, self);
            } else if (
              UserService.user.user_id &&
              self.quiz_type === 'spacedrep' &&
              self.spacedRepQuestionsAnswered >= 25 &&
              !UserService.seen('spacedrep_onboarding_seen') &&
              !$rootScope.embed
            ) {
              UserService.see('spacedrep_onboarding_seen');
              $timeout(self.showSpacedRepOnboarding, 0, true, self);
            }
          }, 250);
          this.currentQuestion.fact.seen = 1;
          answer.selected = true;
          this.quiz_round.num_attempts++;

          if (this.currentQuestion.fact == answer) {
            this.currentQuestion.is_correct = true;
            this.currentQuestion.fact.last_answer = 1;
            this.currentQuestion.answerClass = 'pls-meekus';
            this.correctAudio.play();
            this.quiz_round.num_correct++;
          } else {
            this.currentQuestion.is_correct = false;
            this.currentQuestion.fact.last_answer = 0;
            this.currentQuestion.answerClass = 'pls-error-red';
            this.incorrectAudio.play();
          }

          if (this.quiz_round.card_ids.indexOf(this.currentQuestion.fact.card_id) === -1) {
            this.quiz_round.card_ids.push(this.currentQuestion.fact.card_id);
          }

          $timeout(function () {
            angular.element('.answer-status:visible').focus();
          });

          if (this.quiz_type === 'spacedrep') {
            this.spacedRepQuestionsAnswered = $cookies.get('pls_count_spacedrep_questions')
              ? parseInt($cookies.get('pls_count_spacedrep_questions')) + 1
              : 1;
            $cookies.put('pls_count_spacedrep_questions', this.spacedRepQuestionsAnswered);

            this.questionsAnswered = $cookies.get('pls_count_quiz_questions')
              ? parseInt($cookies.get('pls_count_quiz_questions')) + 1
              : 1;
            $cookies.put('pls_count_quiz_questions', this.questionsAnswered);
          } else {
            this.questionsAnswered = $cookies.get('pls_count_quiz_questions')
              ? parseInt($cookies.get('pls_count_quiz_questions')) + 1
              : 1;
            $cookies.put('pls_count_quiz_questions', this.questionsAnswered);
          }

          if (UserService.user.quiz_show_ratings && self.quizMode === 'multiple-choice') {
            var answersVoteSeen = [];
            for (var a in self.currentQuestion.answers) {
              if (
                self.currentQuestion.answers[a].fact_id != self.currentQuestion.fact.fact_id &&
                self.currentQuestion.answers[a].fact_id
              ) {
                answersVoteSeen.push(self.currentQuestion.answers[a].fact_id);
              }
            }

            FactsResource.updatev3({
              fact_id: self.currentQuestion.fact.fact_id,
              distractor_ids: answersVoteSeen,
              resource: 'distractorviews',
            });
          }

          if (self.LearnService) {
            fact = $filter('filter')(
              self.LearnService.currentFacts,
              { fact_id: self.currentQuestion.fact.fact_id },
              true
            );
            if (fact.length) {
              fact[0].last_answer = self.currentQuestion.fact.last_answer;
            }
          }

          if (UserService.user.user_id) {
            UserService.see('quiz_questions', true);
          }
        }
      },

      endQuiz: function () {
        var self = this;
        self.statsLoaded = false;
        self.manageOpen = false;

        $rootScope.$broadcast('miniPlayerPause');

        if (UserService.user.user_id) {
          TokenService.update();
        }

        self.round.$promise
          .then(function () {
            if (self.currentQuestion.answerSelected) {
              self.splicePicmonic();
              return self.saveFactStat().$promise.then(function () {
                return self.saveRound();
              });
            } else {
              return self.saveRound();
            }
          })
          .then(function (result) {
            self.quizComplete = true;

            self.quizInProgress = false;
            self.playerService.assetsLoaded = false;

            if (self.interval) {
              $interval.cancel(self.interval);
            }

            if (self.LearnService && self.LearnService.audioElement) {
              self.LearnService.audioElement.pause();
            }

            if (
              self.LearnService &&
              self.LearnService.currentCard.entity_type_id === 2 &&
              self.LearnService.currentCard.card_id >= 50000 &&
              self.resource_type == 'picmonic'
            ) {
              self.LearnService.showReviewModal();
            }

            // show review modal for picmonic cards released in the last 90 days after quiz but only one time
            if (
              self.LearnService &&
              self.LearnService.currentCard.entity_type_id === 2 &&
              self.LearnService.currentCard.card_id < 50000 &&
              self.resource_type === 'picmonic' &&
              self.LearnService.currentCard.needs_review === 1 && // release_date > -90 days ago and < 50 ratings
              !self.LearnService.currentCard.user_card_rating && // user hasn't rated it already
              !UserService.seen('post_quiz_rate_' + self.LearnService.currentCard.card_id) // user has only seen this once
            ) {
              UserService.see('post_quiz_rate_' + self.LearnService.currentCard.card_id);
              self.LearnService.showReviewModal();
            }

            window.scrollBy(0, -1000);
            $timeout(function () {
              $('.learn-quiz-results').scrollTop(0);
            }, 0);

            if (UserService.user.user_id) {
              Navigation.topVisible = true;
            }

            self.lastQuestion = self.currentQuestion;
            self.currentQuestion = false;

            self.totalFactsMastered = $filter('filter')(self.facts, {
              last_answer: 1,
            }).length;

            MetaService.replace('%QUIZ%', self.resource.name);
            MetaService.replace('%ACCURACY%', parseInt((self.totalFactsMastered / self.totalFacts) * 100, 10) + '%');

            if (self.totalFactsMastered == self.facts.length) {
              if (self.resource_type === 'track') {
                User.update({
                  resource: 'tracks',
                  resource_id: self.resource_id,
                  quiz_completed: 1,
                });
              } else if (self.quiz_type === 'playlist') {
                Playlists.update({
                  playlist_id: self.resource_id,
                  quiz_completed: 1,
                });
              }
            }

            if (self.xpEarned > 0) {
              $timeout(function () {
                XpService.showAlert(
                  angular.element('.quiz-facts-correct-description'),
                  self.xpEarned,
                  'left: calc(50% + 15px);'
                );
              }, 2000);
            }

            if (result.achievements.length) {
              angular.forEach(result.achievements, function (achievement) {
                $timeout(function () {
                  XpService.showAchievement(achievement);
                }, 2000);
              });
            }

            if (PicmonicQueue.studyplan_id) {
              self.studyPlan = studyplansResource.get({
                studyplan_id: PicmonicQueue.studyplan_id,
              });
            }

            if (
              self.quiz_type != 'spacedrep' &&
              UserService.user.has_seen &&
              (UserService.user.has_seen.quiz_results_sr_1 || 0) < 3
            ) {
              UserService.see('quiz_results_sr_1', true);
              self.showResultsTile = 1;
            } else if (
              UserService.user &&
              UserService.user.has_seen &&
              (UserService.user.has_seen.quiz_results_sr_2 || 0) < 3
            ) {
              UserService.see('quiz_results_sr_2', true);
              self.showResultsTile = 2;
            } else if (
              UserService.user &&
              UserService.user.has_seen &&
              (UserService.user.has_seen.quiz_results_sr_3 || 0) < 3
            ) {
              UserService.see('quiz_results_sr_3', true);
              self.showResultsTile = 3;
            } else {
              self.showResultsTile = false;
            }
          });
      },

      showRegisterModal: function () {
        var self = this;

        if (!UserService.user.user_id) {
          UserService.showRegisterModal(false, 'close', false).result.then(function () {
            if (UserService.user.user_id) {
              self.connectRound();
              Navigation.topVisible = true;
              TokenService.init();
            }
          });
        }
      },

      connectRound: function () {
        User.savev3({
          resource: 'quizround',
          resource_id: this.round.user_quiz_round_id,
          resource2: 'sync',
        });
      },

      saveRound: function () {
        var self = this;

        this.round.resource = 'quizround';
        this.round.resource_id = this.round.user_quiz_round_id;
        this.round.num_attempts = this.quiz_round.num_attempts;
        this.round.num_correct = this.quiz_round.num_correct;
        this.round.card_ids = this.quiz_round.card_ids;
        this.round.hints_used = this.quiz_round.hints_used;

        var promise = this.round.$updatev3();
        promise.then(function () {
          if (self.quiz_type === 'spacedrep') {
            var params = { resource: 'spacedrepstats', source: 'quiz' };

            if (self.stateParams.card_id) {
              params.card_id = self.stateParams.card_id;
            } else if (self.stateParams.track_id) {
              params.track_id = self.stateParams.track_id;
            } else if (self.stateParams.pathway_id) {
              params.pathway_id = self.stateParams.pathway_id;
            } else if (self.stateParams.playlist_id) {
              params.playlist_id = self.stateParams.playlist_id;
            }

            self.spacedRepStats = User.getv3(params, function () {
              self.statsLoaded = true;
            });
          }

          // Notify interested components that the card data has changed
          $rootScope.$broadcast('cardDataChanged', {
            action: 'quiz_attempt',
            card_id: self.resource_type === 'picmonic' ? self.resource_id : null,
            quiz_type: self.resource_type,
          });
          $rootScope.$broadcast('myCardDataChanged', {
            action: 'quiz_attempt',
          });
        });
        return promise;
      },

      selectQuestionFeedback: function (option) {
        this.currentQuestion.reason = option.text;
      },

      saveQuestionSuggestion: function () {
        var self = this;

        if (!self.currentQuestion.severity) {
          return;
        }

        FactsResource.update(
          {
            fact_id: self.currentQuestion.fact.fact_id,
            selected_fact_id: self.currentQuestion.selectedFactId,
            resource: 'questions',
            vote: -1,
            severity: self.currentQuestion.severity,
            reason: self.currentQuestion.reason,
            note:
              self.currentQuestion.reason === 'There is a typo.' ||
              self.currentQuestion.reason === 'There is an academic or information error.'
                ? self.currentQuestion.note
                : '',
          },
          function (data) {
            self.currentQuestion.showQuestionFeedback = false;
          }
        );
      },

      selectDistractorFeedback: function (distractor, option) {
        var self = this;

        if (distractor.reason == option.text) {
          distractor.reason = '';
        } else {
          distractor.reason = option.text;
        }

        self.saveDistractorFeedback(distractor);
      },

      saveDistractorFeedback: function (distractor, close) {
        var self = this;

        if (close) {
          distractor.showFeedback = false;
        }

        FactsResource.updatev3({
          fact_id: self.currentQuestion.fact.fact_id,
          question: self.currentQuestion.question,
          distractor_id: distractor.fact_id,
          resource: 'distractors',
          vote: -1,
          severity: distractor.severity,
          reason: distractor.reason,
          note:
            distractor.reason === "It's similar to the correct answer." ||
            distractor.reason === "It's a correct answer."
              ? distractor.note
              : '',
        });
      },

      retakeQuiz: function () {
        if (this.resource_type === 'track' || this.resource_type === 'pathway') {
          this.startQuiz();
        } else if (this.totalFactsMastered === this.facts.length) {
          this.startQuiz(true);
        } else {
          this.startQuiz();
        }
      },

      newSpacedRep: function () {
        var self = this;
        User.savev3({ resource: 'spacedrep' }, function () {
          self.init('spacedrep', 'today', null, {});
        });
      },

      allSpacedRep: function () {
        User.savev3({ resource: 'spacedrep' }, function () {
          $location.path('/quiz/spacedrep');
        });
      },

      updateSettings: function () {
        UserService.user.$update();
      },

      updateShowPicmonic: function () {
        this.currentQuestion.showPicmonic = UserService.user.quiz_show_picmonic;
        UserService.user.$update();
      },

      updateMute: function () {
        this.incorrectAudio.muted = !this.incorrectAudio.muted;
        this.correctAudio.muted = !this.correctAudio.muted;

        UserService.user.$update();
      },

      preloadImage: function (url) {
        var self = this;
        var img = new Image();
        var suffix = '_half';
        if (self.LearnService) {
          if (window.innerWidth > 768) {
            suffix = '_threequarter';
          } else if (window.innerWidth < 480 || self.LearnService.getSlowSpeedMode()) {
            suffix = '_quarter';
          }
        }
        img.src = String(url).replace('picmonic_assets', 'picmonic_assets' + suffix);
      },

      showQuizLearnPlayer: function () {
        var self = this;
        if (!self.LearnService.currentCard.is_owned) {
          TokenService.redeem(self.currentQuestion.picmonic.card_id).$promise.then(
            function (result) {
              self.currentQuestion.picmonic.is_owned = 1;
              self.LearnService.currentCard.is_owned = 1;
              self.currentQuestion.answered_zoom = true;
              self.LearnService.player_mode = 'learn';
            },
            function () {
              self.currentQuestion.answered_zoom = true;
            }
          );
        } else {
          self.currentQuestion.picmonic.is_owned = 1;
          self.currentQuestion.answered_zoom = true;
          self.LearnService.player_mode = 'learn';
          self.LearnService.startModeTimer('', 'learn');
        }
      },

      showOnboarding: function (self) {
        var offset_audio_bar = $('.audio-bar-wrapper').offset();

        $('body').append(
          '<div class="onboarding-modal-wrapper">' +
            '<div class="onboard-tip bottom-left" style="top: ' +
            (offset_audio_bar.top - 190) +
            'px; left: ' +
            (offset_audio_bar.left + 8) +
            'px; width:304px;">' +
            '<h2 class="pls-font-24 pls-orange">Play the Full Picmonic</h2>' +
            '<p>After answering a question you can click Play to see and learn the full Picmonic with all characters.</p>' +
            '<button id="onboarding-play" class="pls-btn pls-white">PLAY THE FULL PICMONIC</button>' +
            '</div></div>'
        );
        $('body').click(self.hideOnboarding);
        $('#onboarding-play').click(function () {
          // load the real player
          $('.audio-play').click();
          // then actually play the audio
          $timeout(function () {
            $('.audio-play').click();
          }, 0);
        });
        if (UserService.user.user_id) {
          UserService.user.quiz_onboarding_seen = 1;
          UserService.user.$update();
        }
      },

      hideOnboarding: function () {
        $('.onboarding-modal-wrapper').remove();
        $('body').off('click', this.hideOnboarding);
      },

      showDistractorOnboarding: function (self) {
        offset_distractor = $('.incorrect-answer > a').offset();

        // Make sure you've selected a wrong answer
        if (!offset_distractor) {
          return;
        }

        // Make these appear in front of the background
        $('.incorrect-answer').css('position', 'relative');
        $('.incorrect-answer').css('z-index', '1041');
        $('.quiz-answer-container').css('position', 'inherit');

        modalHeight = 335;

        // Desktop
        if (window.innerWidth > 768) {
          // Check to see if the incorrect answer is off the screen
          if (offset_distractor.top > $('.quiz-answer-container').height() + $('.quiz-answer-container').scrollTop()) {
            $('.quiz-answer-container').scrollTop(offset_distractor.top);
          }

          modalTop = offset_distractor.top;
          // Prevent it from going off the bottom of the screen
          if (offset_distractor.top + modalHeight > window.innerHeight) {
            modalTop = window.innerHeight - modalHeight - 8;

            // Prevent it from going off the top of the screen
            if (modalTop < 8) {
              modalTop = 8;
            }
          }
          modalLeft = offset_distractor.left + 304;
          // Mobile
        } else {
          // Check to see if the incorrect answer is off the screen
          if (offset_distractor.top > $('html').height() + $('html').scrollTop()) {
            $('html').scrollTop(offset_distractor.top);
          }
          modalTop = offset_distractor.top - modalHeight - 8;
          modalLeft = offset_distractor.left;
        }

        $('body').append(
          '<div class="distractor-onboarding-modal-wrapper"><div class="modal-backdrop in fade"></div>' +
            '<div class="onboard-tip--light bottom-center" style="top: ' +
            modalTop +
            'px; left: ' +
            modalLeft +
            'px; width:304px;">' +
            '<div class="onboard-tip--light-header"><i class="material-icons md-16" style="margin-left: -8px;margin-right: 4px;">lock_open</i><strong class="pls-font-16 pls-font-raleway pls-magum">Moderation Abilities Unlocked!</strong><i class="material-icons pull-right pls-wet-cement" role="button" tabindex="0">close</i></div>' +
            '<div class="onboard-tip--light-body">' +
            '<i class="material-icons m-l-1 pull-left pls-mugatu">thumb_down</i>' +
            '<p class="m-l-5 pls-font-16 pls-line-height-3"><strong>Downvote</strong> incorrect answers if they are:</p>' +
            '<ul class="m-l-5 m-b-1"><li>too easy</li><li>out of place</li><li>similar to a correct answer</li></ul>' +
            '<i class="material-icons m-l-1 pull-left pls-wet-cement">more_horiz</i>' +
            '<p class="m-l-5 pls-font-16 pls-line-height-3">You can disable <strong>moderation abilities</strong> in the Quiz More Menu.</p>' +
            '<button class="pls-btn pls-btn--block m-t-2 pls-white">GOT IT, THANKS!</button>' +
            '</div></div></div>'
        );
        $('body').click(self.hideDistractorOnboarding);

        UserService.see('distractor_onboarding');
        UserService.user.quiz_show_ratings = 1;
        UserService.user.$update();
      },

      hideDistractorOnboarding: function () {
        $('.quiz-answer-container').css('position', 'relative');
        $('.distractor-onboarding-modal-wrapper').remove();
        $('body').off('click', this.hideDistractorOnboarding);
        $('.incorrect-answer').css('position', 'inherit');
        $('.incorrect-answer').css('z-index', 0);
      },

      showSpacedRepOnboarding: function (self) {
        $('.quiz-answer-container').css('position', 'inherit');
        $('.spacedrep-factor').css('z-index', '1041');
        $('.spacedrep-factor').css('position', 'relative');

        var offset_spacedrep = $('.spacedrep-factor').offset();
        $('.quiz-answer-container').scrollTop(offset_spacedrep.top);
        offset_spacedrep = $('.spacedrep-factor').offset();

        $('body').append(
          '<div class="spaced-rep-onboarding-modal-wrapper"><div class="modal-backdrop in fade"></div>' +
            '<div class="onboard-tip bottom-center" style="top: ' +
            (offset_spacedrep.top - 230) +
            'px; left: ' +
            offset_spacedrep.left +
            'px; width:304px;">' +
            '<h2 class="pls-font-24 pls-orange">Change How Often You are Quizzed on This Fact</h2>' +
            '<p>Choose whether you want to stop seeing this fact in your Daily Quiz, see it less often, or see it more often.</p>' +
            '<button class="pls-btn">THANKS FOR THE TIP!</button>' +
            '</div></div>'
        );
        $('body').click(self.hideSpacedRepOnboarding);
      },

      hideSpacedRepOnboarding: function () {
        $('.spaced-rep-onboarding-modal-wrapper').remove();
        $('.quiz-answer-container').css('position', 'relative');
        $('.spacedrep-factor').css('z-index', '');
        $('.spacedrep-factor').css('position', '');
        $('body').off('click', this.hideSpacedRepOnboarding);
      },

      getQuizTime: function () {
        var time = 0;

        angular.forEach(this.round.questions, function (q) {
          time += q.end_time - q.start_time;
        });

        return time;
      },

      startSmartReviewQuiz: function () {
        var self = this;
        console.log(self.studyPlan);
        $state.go('app.quiz', {
          quiz_type: 'studyplan',
          resource_id: self.studyPlan.studyplan_id,
          questions: self.studyPlan.current_lesson.facts_total,
        });
      },
    };
  },
]);
